<template>
  <v-container grid-list-xs class="mb-3">
    <v-layout row wrap align-center>
      <v-flex xs12 class="text-xs-center">
        <h1 class="display-1">Select Your Plan</h1>
        <p>Please select the plan that you wish to use below.</p>
      </v-flex>
    </v-layout>
    <v-layout class="mt-3">
      <v-container grid-list-lg>
        <v-layout row wrap>
          <v-flex xs-12 md4 offset-md4 class="pa-3" v-if="loading">
            <h2 class="headline text-xs-center">Loading plans...</h2>
            <v-progress-linear indeterminate height="2" color="primary lighten-1"></v-progress-linear>
          </v-flex>
          <v-flex v-if="plans && plans.length === 0" xs12 md4 offset-md4 class="pa-3 mb-5 text-xs-center">
            <v-icon>error_outline</v-icon> Unable to load plans. Please try again later.
          </v-flex>
          <v-flex v-else xs12 md4 v-for="(plan, index) in plans" :key="`plan-${plan.planCode}`" class="pa-3">
            <v-card class="plan--card eq-height" height="100%" :class="{'selected-plan': selectedPlanCode == plan.planCode}">
              <v-card-title>
                <div class="headline"><span v-html="plan.planType"></span></div>
                <div class="details">
                  <span class="plan-price">${{ parseInt( plan.recurringCharge ) }}/month</span><br>
                  <div class="plan-headlines">
                    <div class="plan-headline" v-for="(headline, index) in plan.config.headlines" :key="index">
                      <span>{{headline}}</span>
                    </div>
                  </div>
                  <div class="plan-features">
                    <div class="plan-feature-title" v-if="plan.config.features && plan.config.features.length">FEATURES</div>
                    <div class="plan-feature" v-for="(feature, index) in plan.config.features" :key="index">
                      <span>{{feature}}</span>
                    </div>
                  </div>
                  <div class="plan-fineprints">
                    <div class="plan-fineprint" v-for="(fineprint, index) in plan.config.fineprints" :key="index">
                      <span>{{fineprint}}</span>
                    </div>
                  </div>
                </div>                
              </v-card-title>
              <v-card-actions class="pb-4">
                <v-btn color="accent" class="elevation-0" dark :block="$vuetify.breakpoint.xsOnly" @click="selectPlan(plan.planCode, index)">{{ selectedPlanCode == plan.planCode ? 'Selected Plan' : 'Select Plan' }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>                  
        </v-layout>
        <v-layout row wrap>
          <v-flex xs6 class="text-xs-left pl-3">
            <v-btn
              @click="goBack"
              class="ml-0"
              outline
              color="secondary"
            >&laquo; Back</v-btn>
          </v-flex>
          <v-flex xs6 class="text-xs-right pr-3">
            <v-btn 
              @click="submit" 
              class="mr-0"
              outline
              color="primary"
              :disabled="!selectedPlanCode"
            >Next &raquo;</v-btn>
          </v-flex>
        </v-layout>
      </v-container>  
    </v-layout>    
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedPlanCode: null
    };
  },
  created() {
    this.$store.dispatch("getPlans", this.$store.getters.sim);
    this.selectedPlanCode = this.$store.getters.selectedPlanCode || null;
  },
  mounted() {
    if (!this.$store.getters.sim) {
      this.goBack();
    }
  },
  computed: {
    plans() {
      return this.$store.getters.loadedPlans;
    },
    loading() {
      return this.$store.getters.loading;
    }
  },
  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
    selectPlan(selectedPlanCode, index) {
      this.selectedPlanCode = selectedPlanCode;
      this.$store.dispatch("setSelectedPlanCode", { code: selectedPlanCode });
      this.$store.dispatch("setSelectedPlan", { plan: this.plans[index] });
    },
    submit() {
      // save plan selection

      // go to phone number selection
      this.$router.push("/select-number");
    }
  }
};
</script>

<style lang="scss" scoped>
.headline {
  margin: 0 auto 20px;
  width: 100%;
}

.details {
  margin: 0 auto;
  width: 100%;
}

.plan-price {
  color: #1e93b5;
  font-size: 18px;
}

.plan-headlines {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
  min-height: 145px;

  & .plan-headline:not(:first-child) {
    padding-top: 10px;
  }
  & .plan-headline {
    text-transform: uppercase;
    & /deep/ span {
      color: #105079;
      display: block;
      // padding: 8px 0;
    }
  }
}

.plan-feature-title {
  text-transform: uppercase;
  color: #1e93b5;
  padding-top: 10px;
  padding-bottom: 10px;
}

.plan-features {
  min-height: 110px;
  // & .plan-feature {
  //   & /deep/ span {
  //   }
  // }
}

.plan-fineprints {
  padding-top: 20px;
  // height: 85px;
  & .plan-fineprint {
    & /deep/ span {
      font-size: 11px;
    }
  }
}

.plan--card {
  text-align: center;
  background: #fff;
  position: relative;
  // box-shadow: 0 3px 3px 0px rgba(183, 183, 183, 0.5);
  transition: 0.8s cubic-bezier(0.2, 1, 0.2, 1);
  // border: 5px solid #105079 !important;

  box-shadow: 0 2px 12px 0 rgba(212, 212, 212, 0.5);
  border: 5px solid transparent !important;

  &.selected-plan {
    transform: scale(1.03) translateY(-6px);
    // box-shadow: 0 6px 18px 0px rgba(183, 183, 183, 0.9);
    border: 5px solid #61b6d6 !important;
    box-shadow: 0 5px 22px 0 rgba(212, 212, 212, 0.8);

    // background: #105079;
    // color: #fff;

    // .plan-price {
    // color: #fff;
    // }
  }

  .card__actions {
    .btn {
      margin: 0 auto;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/activation/PlanSelection.vue